import React from 'react';
export function Footer() {
  return <footer className="bg-[#08080c] py-12 border-t border-dark-border" data-id="element-42">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-43">
        <div className="mb-8" data-id="element-44">
          <span className="font-display font-bold text-3xl tracking-widest text-white opacity-80" data-id="element-45">
            ODYSSEY
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-gray-400 text-sm font-medium" data-id="element-46">
          <a href="#" className="hover:text-white transition-colors" data-id="element-47">
            Política de privacidad
          </a>
          <span className="hidden sm:inline text-dark-border" data-id="element-48">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-49">
            Contacto
          </a>
          <span className="hidden sm:inline text-dark-border" data-id="element-50">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-51">
            Reembolsos
          </a>
        </div>

        <p className="text-gray-500 mb-8 max-w-md" data-id="element-52">
          Nuestra misión: liberar a 100,000 hombres de la adicción a la
          pornografía.
        </p>

        <p className="text-gray-600 text-xs" data-id="element-53">
          &copy; {new Date().getFullYear()} Odyssey. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}